<template>
    <div class="addPool">
        <el-form :model="addForm" ref="addForm">
            <el-form-item label="入池扣费规则：" :label-width="formLabelWidth">
                <el-select v-model="addForm.joinRule" filterable clearable>
                    <el-option value="">请选择入池扣费规则</el-option>
                    <el-option
                        v-for="item in xianxingArrEdit"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                <!-- <div style="color: #f00">入池扣费规则只能选择线性扣费规则</div> -->
            </el-form-item>
            <el-form-item
                label="超量扣费规则："
                :label-width="formLabelWidth"
                required
                prop="overFlowRule"
            >
                <el-select v-model="addForm.overFlowRule" filterable clearable>
                    <el-option value="">请选择超量扣费规则</el-option>
                    <el-option
                        v-for="item in dialogEditRuleLists"
                        :key="item.value"
                        :label="getRuleDisplayLabel(item)"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                label="备注"
                :label-width="formLabelWidth"
                prop="name"
            >
                <el-input
                    v-model="addForm.remark"
                    autocomplete="off"
                ></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
            <el-button
                type="primary"
                @click="uploadExcel('addForm')"
                class="themed-button"
                >提交</el-button
            >
            <el-button type="info" @click="cancelDialog()" class="themed-button"
                >取 消</el-button
            >
        </div>
    </div>
</template>
<script>
import { editCardPool } from "@/api/trafficPoolManagement.js";
import loading from "@/utils/Loading.js";
export default {
    name: "editCardPool",
    props: ["dialogEditRuleLists", "edit"],
    data() {
        return {
            addForm: {
                joinRule: "",
                overFlowRule: "",
                remark: "",
                id: "",
            },
            formLabelWidth: "150px",
            xianxingArrEdit: [],
        };
    },
    watch: {
        dialogEditRuleLists(value) {
            //console.log(value)
            this.xianxingArrEdit = value.filter((element) => element.type == 1);
            console.log(this.xianxingArrEdit);
        },
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            this.addForm.joinRule = this.edit.joinRule;
            this.addForm.overFlowRule = this.edit.overFlowRule;
            this.addForm.remark = this.edit.remark;
            this.addForm.id = this.edit.id;
        },
        cancelDialog() {
            this.$emit("close");
        },
        // 检查超量扣费规则是否为默认类型
        checkOverFlowRuleType() {
            if (!this.addForm.overFlowRule) {
                return true; // 如果没有选择，允许通过
            }

            const selectedRule = this.dialogEditRuleLists.find(
                (rule) => rule.value === this.addForm.overFlowRule
            );
            if (selectedRule && selectedRule.category !== 0) {
                this.$message({
                    showClose: true,
                    message: "超量扣费规则只能选择默认规则类型",
                    type: "error",
                });
                return false;
            }
            return true;
        },
        // 获取规则显示标签，包含规则类型信息
        getRuleDisplayLabel(item) {
            let typeText = "";
            let categoryText = "";

            // 根据type字段显示类型
            if (item.type == "1") {
                typeText = "线性";
            } else if (item.type == "2") {
                typeText = "阶梯";
            }

            // 组合显示：规则名称 (类型-规则类型)
            if (typeText && categoryText) {
                return `${item.label} (${typeText}-${categoryText})`;
            } else if (typeText) {
                return `${item.label} (${typeText})`;
            } else if (categoryText) {
                return `${item.label} (${categoryText})`;
            } else {
                return item.label;
            }
        },
        uploadExcel(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 检查超量扣费规则类型
                    if (!this.checkOverFlowRuleType()) {
                        return false;
                    }

                    loading.show();
                    editCardPool(this.addForm).then((responseResult) => {
                        if (responseResult.slide_msg_key == 1) {
                            this.$alert(
                                responseResult.slide_msg_message_key,
                                "提示",
                                {
                                    confirmButtonText: "确定",
                                }
                            );
                            return;
                        }
                        // this.$emit("refresh")
                        this.$emit("close");
                    });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
